import type { LoaderFunctionArgs } from '@remix-run/node';
import { Card, CardContent } from '~/components/card';
import { Logo } from '~/components/logo';
import { VStack } from '~/components/stack';
import { SignIn } from '~/features/auth/sign-in';
import { authenticator } from '~/services/auth.server';
import { ROUTES } from '~/utils/routes';

function AuthSignInPage() {
  return (
    <Card>
      <CardContent className="p-12">
        <VStack className="gap-8">
          <a href={ROUTES.LANDING.HERO}>
            <Logo />
          </a>
          <h2 className="text-3xl font-bold !leading-snug">
            Log in to your account
          </h2>
          <SignIn />
        </VStack>
      </CardContent>
    </Card>
  );
}

export async function loader({ request }: LoaderFunctionArgs) {
  return await authenticator.isAuthenticated(request, {
    successRedirect: ROUTES.DECKS.BROWSE,
  });
}

export const shouldRevalidate = () => false;

export default AuthSignInPage;
